<template>
    <div class="tours">
        <div class="top">
            <div class="title">科普视频</div>
        </div>
        <div class="nav">
            <div class="nav-con">
                <div class="list" @click="changeNav(index)" :class="currentNav == index ? 'active' : ''"
                    v-for="(item, index) in navList" :key="index">
                    {{ item.nav_title }}
                </div>
            </div>
        </div>

        <div class="hot-video">
            <div class="w-1200">
                <!-- <div class="left">
                    <div class="left-title">筛选</div>
                    <div class="left-lists" v-if="navList[currentNav] && navList[currentNav].nav_p_list">
                        <div class="list" :class="currentItemNav == index ? 'active' : ''"
                            v-for="(item, index) in navList[currentNav].nav_p_list" @click="changeItemNav(index)"
                            :key="item.id">
                            {{ item.nav_title }}
                        </div>
                    </div>
                </div> -->
                <div class="lists">
                    <div class="list" @click="videoInfo = item; dialogVisible = true;" v-for="item in videoList"
                        :key="item.nav_id" v-appear-animation="{ appearClass: 'animate-fade-out' }">
                        <img :src="item.image_url"></img>
                        <p class="list-text">{{ item.news_title }}</p>
                    </div>
                </div>
            </div>
            <div class="no-data" v-if="videoList.length == 0">
                <img src="../../assets/imgs/no-data.png" alt="">
                <p>暂无数据</p>
            </div>
            <el-pagination class="pagination" background layout="prev, pager, next" :total="total" :current-page="page"
                :page-size="pageSize" @size-change="handleSizeChange">
            </el-pagination>
        </div>
        <el-dialog :title="videoInfo.news_title" :visible.sync="dialogVisible" width="40%">
            <video v-if="dialogVisible" style="width: 100%;height: 70vh;" :src="videoInfo.url" controls></video>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            currentNav: 0,
            currentItemNav: 0,
            navList: [],
            videoList: [],
            videoInfo: {
                news_title: '',
                url: ''
            },
            total: 0,
            page: 1,
            pageSize: 10,
            dialogVisible: false
        }
    },
    mounted() {
        this.getType()
    },
    methods: {
        getType() {
            this.$http.video_nav_list({
                type_id: 777
            }).then(res => {
                this.navList = res.data;
                this.news_id = res.data[0].nav_id;
                this.getVideoList()
            })
        },
        getVideoList() {
            this.$http.video_list({
                type_id: this.news_id,
            }).then(res => {
                this.videoList = res.data;
                this.total = res.count;
            })
        },
        changeNav(index) {
            this.currentNav = index
            this.currentItemNav = null
            this.news_id = this.navList[index].nav_id
            this.getVideoList()
        },
        changeItemNav(index) {
            this.currentItemNav = index;
            this.news_id = this.navList[this.currentNav].nav_p_list[index].nav_id
            this.getVideoList()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getVideoList()
        },
        handleCurrentChange(val) {
            this.page = val
            this.getVideoList()
        },
        getvideoInfo(item) {
            this.videoInfo = item
            this.dialogVisible = true
        }
    }
}
</script>

<style lang="less" scoped>
.tours {
    padding-bottom: 100px;
    background-color: #f1f1f1;

    .no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin: 150px 0;
        color: #222222;

        img {
            width: 150px;
        }
    }

    .pagination {
        margin: 60px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .hot-video {
        padding: 60px 0 120px;

        .w-1200 {
            max-width: 1200px;
            margin: 0 auto;
            display: flex;

            .left {
                width: 200px;
                flex-shrink: 0;
                margin-right: 10px;

                .left-title {
                    font-size: 18px;
                    color: #222222;
                    font-weight: 500;
                    padding: 10px 0;
                }

                .list {
                    font-size: 16px;
                    margin: 5px;
                    cursor: pointer;
                    color: #666666;
                    padding: 2px 5px;
                    border-radius: 4px;
                }

                .list.active {
                    color: #fff;
                    font-weight: 500;
                    background-color: #222222;
                }

                .left-lists {
                    padding-top: 10px;
                    display: flex;
                    flex-wrap: wrap;

                }
            }

            .lists {
                flex: 1;
                display: flex;
                flex-wrap: wrap;

                .list {
                    width: calc(25% - 20px);
                    margin-right: 23px;
                    margin-bottom: 30px;
                    cursor: pointer;

                    &:hover {

                        video,
                        img {
                            box-shadow: 0 8px 7px 0 rgba(0, 0, 0, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.1);
                        }
                    }
                }

                video,
                img {
                    transition: .3s all;
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    border-radius: 8px;
                }

                .list:nth-of-type(4n) {
                    margin-right: 0;
                }

                .list-text {
                    padding: 10px;
                    box-sizing: border-box;
                    font-size: 18px;
                    text-align: center;
                    color: #222222;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }

    .content {
        max-width: 1200px;
        margin: 50px auto;
        display: flex;

        .left {
            width: 200px;
            flex-shrink: 0;

            .list {
                background-color: #fff;
                font-size: 16px;
                color: #222222;
                height: 45px;
                display: flex;
                align-items: center;
                text-indent: 15px;
                border-bottom: 1px solid #9a730674;
                cursor: pointer;
                transition: .3s all;
            }

            .list:nth-last-child(1) {
                border-bottom: none;
            }

            .list:hover,
            .list.active {
                color: #666666;
                background-color: #40403f1c;
            }
        }

        .right {
            flex: 1;
            margin-left: 20px;

            .right-con {
                background-color: #fff;
                padding: 20px;

                .right-con-title {
                    font-size: 20px;
                    color: #222222;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #9a730674;
                }

                .right-con-text {
                    font-size: 16px;
                }
            }

            .right-con-text {
                padding: 20px 10px;
                box-sizing: border-box;
            }
        }
    }

    .nav {
        width: 100%;
        padding: 20px 0;
        background-color: #fff;

        .nav-con {
            // max-width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;

            .list {
                font-size: 16px;
                height: 60px;
                padding: 0 10px;
                margin: 0 10px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: center;
                transition: .3s all;
                color: #666;
            }

            .list:nth-last-child(1) {}

            // .list.active {
            //     position: relative;
            //     color: #222222;
            //     transform: scale(1.1);
            //     border-radius: 6px;

            //     &::after {
            //         content: '';
            //         left: 50%;
            //         transform: translateX(-50%) scaleY(0.8);
            //         position: absolute;
            //         width: 80px;
            //         height: 2px;
            //         bottom: 10px;
            //         background-color: #222222;
            //     }
            // }

            .list:hover,
            .list.active {
                color: #666666;
                background-color: #40403f1c;
            }

        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/migration.jpg');
        background-size: auto 100%;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #fff;
            text-shadow: 3px 3px 5px #222222;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: auto 110%;

            img {
                transform: scale(1.1);
            }
        }
    }


}

@media (max-width: 600px) {
    .tours {
        padding-bottom: 0;

        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .nav {
            .nav-con {
                .list {
                    font-size: 12px;
                    height: 35px;
                    margin: 5px 5px;
                }
            }
        }

        .hot-video {
            padding: 50px 0 80px;

            .w-1200 {
                display: block;
                padding: 0 20px;
                box-sizing: border-box;

                .left {
                    width: 100%;
                }

                .lists {
                    margin-top: 20px;

                    .list {
                        width: calc(50% - 10px);
                        margin-right: 20px;
                    }

                    .list:nth-child(2n) {
                        margin-right: 0;
                    }
                }
            }

        }

        .pagination {
            margin: 30px auto 0;
        }

        .no-data {
            margin: 20px 0 50px;
            font-size: 14px;

            img {
                width: 80px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/video.vue